// packages/is-shallow-equal/src/arrays.ts
function isShallowEqualArrays(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0, len = a.length; i < len; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
export {
  isShallowEqualArrays as default
};
//# sourceMappingURL=arrays.js.map
